/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { observable, action } from "mobx";
import { BOTTOM_PANEL_HIDE_TIMEOUT } from "constants/constants";

class BottomBoardStore {
  @observable showPanel;
  @observable showBanner;
  @observable panelDropinId;
  @observable panelProps;
  @observable Banner;
  @observable config;
  @observable boundingBox;
  @observable showProximityView;
  @observable enableAutoHideNShow;
  bottomBannerConfig;
  isSyntheticScroll;
  @observable shouldShowBottomBanner;

  constructor() {
    this.init();
  }

  initStore(stores) {
    if (stores) {
      this.stores = stores;
    }
  }

  @action
  init() {
    this.panelDropinId = null;
    this.panelProps = {};
    this.Banner = null;
    this.config = {
      hideAndOpenOnLHP: true,
      hideAndOpenOnRHP: true,
      enableAnimation: true,
      hideAndOpenOnZoom: true,
      hideAndOpenOnScroll: true,
      hideAndOpenOnRHPResize: true,
      hideOnSelection: true,
      hideAfter: BOTTOM_PANEL_HIDE_TIMEOUT,
      skipHideAndOpenOnLHP: [],
      skipHideAndOpenOnRHP: [],
      panelWidth: 0
    };
    this.boundingBox = {
      height: 0
    };
    this.showProximityView = false;
    this.enableAutoHideNShow = false;
    this.hidePanelActiveStates = new Set();
    this.bottomPanelRect = {};
    this.scrollStart = 0;
    this.lhpRhpSkipStates = new Set();
    this.bottomBannerConfig = {};
    this.isSyntheticScroll = true;
    this.shouldShowBottomBanner = undefined;
  }

  @action
  setPanelVisibility(value) {
    if (!value || (this.hidePanelActiveStates.size === 0 && this.lhpRhpSkipStates.size !== 2)) {
      this.showPanel = value;
    }

    if (this.config && this.config.hideAfter && this.enableAutoHideNShow && !value) {
      this.showProximityView = true;
    }
  }

  @action
  setBannerVisibility(value) {
    this.showBanner = value;
  }

  @action
  setPanel(value, props) {
    this.panelDropinId = value;
    this.panelProps = props;
  }

  @action
  setBanner(value) {
    this.Banner = value;
  }

  @action
  setConfig(value) {
    this.config = value;
  }

  @action
  setBoundingBox(value) {
    this.boundingBox = value;
  }

  addToHidePanelActiveStates(value) {
    this.hidePanelActiveStates.add(value);
  }

  deleteFromHidePanelActiveStates(value) {
    this.hidePanelActiveStates.delete(value);
  }

  addToLhpRhpSkipStates(value) {
    this.lhpRhpSkipStates.add(value);
  }

  deleteFromLhpRhpSkipStates(value) {
    this.lhpRhpSkipStates.delete(value);
  }

  @action
  setEnableAutoHideNShow(value) {
    if (this.config && this.config.hideAfter) {
      if (!value || (this.hidePanelActiveStates.size === 0 && this.lhpRhpSkipStates.size !== 2)) {
        this.enableAutoHideNShow = value;
      }
    }
  }

  @action
  reset() {
    this.init();
  }

  setBottomPanelRect(bottomPanelRect) {
    this.bottomPanelRect = bottomPanelRect;
  }

  setScrollStart(scrollStart) {
    this.scrollStart = scrollStart;
  }

  setBottomBannerConfig(value) {
    this.bottomBannerConfig = value;
  }

  setIsSyntheticScroll(value) {
    this.isSyntheticScroll = value;
  }

  @action
  setShouldShowBottomBanner(value) {
    this.shouldShowBottomBanner = !!value;
  }
}

export { BottomBoardStore };
